import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogInitiativesInitiativeDescriptionRoute extends Route {
  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeDescriptionRoute,
);
